(() => {
  'use-strict';

  const buttonsHeroBanner = document.querySelectorAll('.js-product-hero-banner-actions a');

  function init(elements) {
    elements.forEach((element) => {
      // Check that the target is not already initialized
      if ('init' in element.dataset) {
        return;
      }
      element.dataset.init = true;

      const initialContainer = element.closest('.region-sidebar-second');

      document.addEventListener('breakpointChange', (event) => {
        if (!(event.detail.breakpoints.includes('desktop'))) {
          // Mobile / tablet case
          // Insert the sticky menu at is initial place (region-sidebar-second)
          initialContainer.insertBefore(element, null);
        } else {
          // Desktop case
          // Insert the sticky menu at the end of the SideBarMenu
          const sidebar = document.querySelector('.js--program-anchor-block-active .js-side-bar-product');
          sidebar.insertBefore(element, null);
        }
      }, false);

      const buttonsStickyMenu = element.querySelectorAll('.block-views-blocksticky-menu-block-2 button');

      if (buttonsStickyMenu.length !== 0) {
        buttonsStickyMenu.forEach((buttonElement) => {
          // copy title of reference button for RGAA
          buttonsHeroBanner.forEach((buttonHeroElement, key) => {
            if (buttonHeroElement.innerText.trim().substring(0, 5)
              === buttonElement.innerText.trim().substring(0, 5)) {
              buttonElement.setAttribute('title', buttonHeroElement.getAttribute('title'));
              buttonElement.addEventListener('click', () => {
                buttonsHeroBanner[key].click();
              });
            }
          });
        });
      }
    });
  }

  Drupal.behaviors.stickySidebarProduct = {
    attach: () => {
      const elements = document.querySelectorAll('.js-sticky-menu-product');
      if (elements.length !== 0) {
        init(elements);
      }
    },
  };
})();
